const TAGS_HIERARCHY_MAX_DEPTH = 10;
export const TAGS_HIERARCHY_PATH = '(/:tags)'.repeat(TAGS_HIERARCHY_MAX_DEPTH);
